import { render } from "./QuizAnswerResultFrame.vue?vue&type=template&id=62f9a545&scoped=true"
import script from "./QuizAnswerResultFrame.vue?vue&type=script&lang=js"
export * from "./QuizAnswerResultFrame.vue?vue&type=script&lang=js"

import "./QuizAnswerResultFrame.vue?vue&type=style&index=0&id=62f9a545&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f9a545"]])

export default __exports__